import { Component, OnDestroy } from '@angular/core';
import {
    NavController,
    ViewController,
    NavParams,
    LoadingController,
    AlertController,
    ToastController,
    ModalController,
} from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Storage } from '@ionic/storage';
import { InAppBrowser, InAppBrowserOptions } from '@ionic-native/in-app-browser';
import { provider } from '../../providers/provider';
import { Subject } from 'rxjs';
import { AppVersion } from '@ionic-native/app-version';
import moment from 'moment';

import { Failure } from '../failure/failure';
import { Success } from '../success/success';
import { AddAddressPage } from '../account/addAddress/addAddress';
import { Events } from 'ionic-angular';
import { CustomizerProvider } from '../../providers/customizer/customizer';
import { CouponPage } from '../coupon/coupon';
@Component({
    selector: 'page-confirm',
    templateUrl: 'confirm.html',
})
export class ConfirmPage implements OnDestroy {
    summary: any;
    tot: any;
    valuta: any;
    len: any;
    righe = [];
    riga = {};
    varianti = [];
    variante = {};
    message: any;
    url: any;
    data: any;
    button_text: any;
    message_text: any;
    creditoResiduo: any;
    fidelityCardThreshold: any;
    options: InAppBrowserOptions = {
        location: 'no',
        hardwareback: 'no',
        toolbar: 'yes',
        toolbartranslucent: 'no',
        toolbarposition: 'top',
        toolbarcolor: '#FFFFFF'
    };
    number: any;
    note: string = '';
    customerInfo: any;
    address;
    slots;
    takeAway = {
        place: {},
        address: '',
        mode: '',
        schedule: '',
        note: '',
        deliveryCost: 0,
        deliveryDiscount: 0
    };
    takeHome = false;
    loadOrder = 0;
    onAddressChangedSubscription: any;
    // deliveryFees;
    private _onDestroy = new Subject();
    wrongAddress = '';
    baseDate;
    days = [];
    sendOrderInProgress = false;
    sendOrderInProgressAndPayWithCreditCard = false;
    hash = '';
    temporaryCustomer = null;
    homeDiscount = 0;
    shopDiscount = 0;
    //totalWithDiscount = 0;
    version = "4";
    takeAwayPlace = {
        address: '',
        number: '',
        name: '',
        city: '',
        zipCode: ''
    };
    locale: string;
    appVersion = '';
    getTot = false;
    selectedAddress = {
        address: '',
        number: '',
        country: '',
        city: '',
        zipCode: ''
    };
    infoTakeAway = {
        finalTotal: 0,
        totalWithDiscount: 0,
        productsTotal: 0,
        deliveryCost: 0,
        discount: 0,
        minCostThresholdForCustomCost: 0,
        deliverableOrderThreshold: 0,
        minimumForCustomDeliveryCostAchieved: false,
        minimumDeliverableAchieved: false,
        creditCardPayable: true,
        creditCardThreshold: 0,
        cashPayable: true
    };
    modeTakeAwayOrDelivery = '';
    whenTakeAwayOrDelivery = null;
    isMenuOk = true;
    coupons = [];
    totalCouponDiscount = 0;
    totalFromServer = null;
    paymentTimeout: any;
    paymentInterval: any;
    overorderedProducts = null;

    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        public toastCtrl: ToastController,
        public alertCtrl: AlertController,
        private iab: InAppBrowser,
        public loadingCtrl: LoadingController,
        public translateService: TranslateService,
        public storage: Storage,
        private modalCtrl: ModalController,
        public viewCtrl: ViewController,
        public AppVersion: AppVersion,
        public events: Events,
        public customizer: CustomizerProvider,
        public provider: provider
    ) {

        storage.get('versione').then((value) => {
            this.AppVersion.getVersionCode().then(version => {
                if (value) {
                    if (value.ios) this.appVersion = "ios/" + version
                    else if (value.android) this.appVersion = "android/" + version
                    else this.appVersion = 'browser'
                } else this.appVersion = 'browser'
            }).catch(error => {
                this.appVersion = 'browser'
            });
        })
        
        this.url = provider.getUrl();
        
        let data = provider.getMenu();

        let getDateForTakeAwayOrDelivery = this.provider.getDateForTakeAwayOrDelivery();

        if(getDateForTakeAwayOrDelivery && getDateForTakeAwayOrDelivery != undefined) {
            this.storage.get('modeTakeAwayOrDelivery').then((mode) => {
                this.modeTakeAwayOrDelivery = mode;
                if(mode == 'home') 
                    this.takeHome = true;
            });
            this.whenTakeAwayOrDelivery = getDateForTakeAwayOrDelivery;
            this.baseDate = this.whenTakeAwayOrDelivery.slot;
        }

        if (data.menu.itsClassMenu && data.settings.payment.when == 'PAGADOPO') { 
            data.settings.payment.when = 'PAGAORA';
            data.settings.payment.how.card = true;
            this.data = data;
        } else {
            this.data = data;
        }

        // this.data = provider.getMenu();
        this.temporaryCustomer = provider.getTemporaryCustomer();
        this.summary = provider.getCart();
        this.righe = navParams.get('ordine');
        // this.deliveryFees = parseFloat(this.data.menu.deliveryPriceModifiers.freeDeliveryThreshold);
        // this.tot = navParams.get('tot');
        this.valuta = navParams.get('valuta');

        // populate customer
        this.retrieveCustomer();
        this.getFidelity();
        //this.prepareDiscounts();

        // calcolo del totale dal server
        this.calcolaTotale();

        // calcolo dell'impegno dell'ordine
        this.calcoloImpegnoOrdine();

        // bind to address changed
        this.events.subscribe('user:updated', (user) => {
            this.retrieveCustomer();
        });

        // bind to coupons changed
        this.events.subscribe('coupons:updated', (coupon) => {
            this.calcolaTotale();
        });

        this.events.subscribe('takeHome:updated', () => {
            this.calcolaTotale();
        });

        if(this.righe[0].prod.trendCustomProperties) {
            this.righe[0].prod.trendCustomProperties.futureReservationDays.forEach(element => {
                let trendDate = new Date(element);
                trendDate.setDate(trendDate.getDate());
                trendDate.setHours(0,0,0,0);
                this.days.push(trendDate)
            });
        } else {
            // FEB 2021: ora il controllo dei giorni lavorativi è fatto dal server
            this.getWorkingDays();
        }

        // set take home flag automatically is shop is only in home mode
        this.takeHome = (this.data.menu.takeAwayOptions == 'home');

        // load slots - PLEASE KEEP THIS LINE AFTER THE "this.takeHome = ""
        this.getSlots(); 

        this.locale = this.translateService.currentLang.toUpperCase();

        this.takeAway.schedule = this.whenTakeAwayOrDelivery;
    }

    // giorni lavorativi dal server
    getWorkingDays() {
        this.provider.getWorkingDays().subscribe(slots => {
            this.days = JSON.parse((<any>slots)._body);
        }, err => {
            console.log(err);
        });
    }

    calcolaTotale() {

        let loading = this.loadingCtrl.create({
            content: '<ion-spinner name="circles"></ion-spinner>'
        });
        loading.present();

        if(this.takeAway.address.length == 0 && this.data.tavolo.isTakeAway && this.takeHome) {
            loading.dismiss();
            return;
        } 

        this.getTot = false;
        let obj = {
            idMenu: this.data.menu._id,
            deliveryAddress: {
                address: this.selectedAddress.address,
                number: this.selectedAddress.number,
                city: this.selectedAddress.city,
                country: this.selectedAddress.country,
                zipCode: this.selectedAddress.zipCode
            },
            couponsApplied: this.provider.getAppliedCoupons(),
            order: this.righe,
            isFirstOrder: this.provider.isFirstOrder(),
            deliveryMode: this.data.tavolo.isTakeAway ? (this.takeHome ? 'home' : 'shop') : 'self',
            customerId: this.customerInfo && this.customerInfo !== null ? this.customerInfo._id : null
        };

        this.provider
        .getTotalFromServer(obj)
        .takeUntil(this._onDestroy)
        .subscribe((data) => {
            this.totalFromServer = JSON.parse((<any>data)._body);
            this.coupons = (this.totalFromServer.couponsApplied).filter((coupon) => coupon.discardReason == null);
            this.totalCouponDiscount = this.totalFromServer.totalCouponDiscount;
            this.takeAway.deliveryCost = this.totalFromServer.deliveryCost;
            this.takeAway.deliveryDiscount = -this.totalFromServer.discount;
            this.overorderedProducts = this.totalFromServer.overorderedProducts && (this.totalFromServer.overorderedProducts.length == 0) ? null : this.totalFromServer.overorderedProducts;
            //this.totalWithDiscount = this.tot - this.infoTakeAway.discount;
            this.getTot = true;
            this.infoTakeAway = this.totalFromServer;
            if(this.totalFromServer.discardedCoupons.length !== 0) {
                this.totalFromServer.discardedCoupons.forEach(element => {
                    this.deleteCoupon(element.code);
                    const toast = this.toastCtrl.create({
                        message: "Coupon non valido: " + element.code,
                        duration: 3000,
                        position: 'middle',
                    });
                    toast.present();
                });
            }
            if (this.overorderedProducts) {
                this.overorderedProducts.forEach(element => {
                    const toast = this.toastCtrl.create({
                        message: "Il prodotto \"" + element.product.content.descrizione[0].contenuto + "\" ha raggiunto il limite massimo ordinabile dal vostro tavolo (max: " + element.maxOrderableQuantity +"pz). PER PROCEDERE CON L'INVIO DELL'ORDINE, DOVETE PRIMA RIMUOVERLO",
                        closeButtonText: 'OK',
                        showCloseButton: true,
                        position: 'middle',
                    });
                    toast.present();
                });
            }
            loading.dismiss();
        }, (err) => {
            loading.dismiss();
            const toast = this.toastCtrl.create({
                message: "Errore di rete... riprova!",
                duration: 3000,
                position: 'middle',
            });
            toast.present();
            this.dismiss();
        });
    }

    calcoloImpegnoOrdine() {
        let prodCost = 0;
        for (let riga of this.summary) {
            if (!riga.prodotto.content.noProductionCost) {
                prodCost = prodCost + riga.quantita;
            }
        }

        if (prodCost == 0) {
            this.data.menu.takeAwayOptions = 'shop';
            this.loadOrder = prodCost;
        } else if (this.data.settings.shopOrderHasWeightZero && !this.takeHome) {
            console.log('load order is zero')
            this.loadOrder = 0;
        } else {
            if (this.data.settings.orderWeightIsOne && prodCost !== 0) {
                this.loadOrder = 1;
            } else {
                this.loadOrder = prodCost;
            }
        }
    }

    validationTakeAwayOrder() {
        if (this.data.tavolo.itsHotelRoom || this.data.tavolo.isTakeAway) {
            if (!this.takeAway.schedule) {
                return true;
            } else if (!this.takeAway.address && this.takeHome) {
                return true;
            } else if (this.wrongAddress != '' && this.takeHome) {
                return true;
            } else if (!this.infoTakeAway.minimumDeliverableAchieved) {
                return true;
            } else if (this.data.settings.businessAddresses.length > 0 && !this.takeHome && this.takeAwayPlace.address == '') {
                return true;
            }
            /*else if(this.totalWithDiscount < this.infoTakeAway.deliverableOrderThreshold) {
                return true;
            }*/
        }
        return false;
    }

    takeAwayHome(event) {
        this.getSlots();
        this.takeHome = event.value;
        //this.totalWithDiscount = this.tot - this.infoTakeAway.discount;
        if (event.value) {
            this.takeAway.place = {};
            this.takeAwayPlace = { address: '', number: '', name: '', city: '', zipCode: '' };
        } else {
            this.wrongAddress = '';
        }
    }

    getFidelity() {
        if(this.provider.getPrepaidCard()) {
            this.storage.get(this.data.settings.customercode).then((hash) => {
                this.hash = hash;
                this.provider
                    .getCardBalance(hash)
                    .takeUntil(this._onDestroy)
                    .subscribe(
                    (data) => {
                        let tessera = JSON.parse((<any>data)._body);
                        this.creditoResiduo = tessera.valore;
                        this.fidelityCardThreshold = tessera.valore_minimo;
                    },
                    (err) => {
                        this.hash = '';
                    }
                    );
            });
        }
    }

    ngOnDestroy() {
        this._onDestroy.next();
    }

    mapAddressCode() {
        let items = JSON.parse(sessionStorage.getItem('comuni'));

        for (let address of this.customerInfo.addresses) {
            items.filter((item) => {
                if (item.name.toLowerCase() == address.city.toLowerCase()) {
                    address.code = item.code;
                }
            });
        }
    }

    changeTakeAwayPlace(event) {
        //console.log(event)
        this.takeAwayPlace = event;
    }

    controlAddress(event) {
        let address = this.takeAway.address;
        // exit immediately if no address is entered or we are in hotel mode
        if (!address || this.data.tavolo.itsHotelRoom) return;
        // process address
        const item = this.customerInfo.addresses.filter((item) => item.id == address);

        this.selectedAddress = item[0];
        // enable the wrong address prompt
        this.translateService
        .get('INVALID_ADDRESS')
        .takeUntil(this._onDestroy)
        .subscribe((msg) => {
            if(item[0].code !== undefined) {
                this.provider
                    .getShops(item[0].code)
                    .subscribe(
                        (shops) => {
                            let negozi = JSON.parse((<any>shops)._body);

                            let result = negozi.filter((negozio) => negozio.customercode == this.data.settings.customercode);

                            if(result.length == 0)
                                this.wrongAddress = msg;
                            else {
                                this.wrongAddress = '';
                                this.events.publish('takeHome:updated');
                            }
                        },
                        (err) => {
                            this.wrongAddress = msg;
                            console.log('No restaurants found');
                        }
                    );
            }
        });
    }

    getSlots() {
        // send a null as deliverymode if not specified elsewhere
        const deliveryMode = this.takeHome ? 'home' : 'shop';
        let date = this.baseDate;
        if(moment().isSame(this.baseDate, 'year') &&
            moment().isSame(this.baseDate, 'month') &&
            moment().isSame(this.baseDate, 'day')) {
            date = moment(date);
            date.set({h: moment().hour(), m: moment().minute(), s: moment().second()});
            date = date.format();
        }
        this.provider.getSlots(date, deliveryMode).takeUntil(this._onDestroy).subscribe(slots => {
            this.slots = JSON.parse((<any>slots)._body);
            this.takeAway.schedule = this.whenTakeAwayOrDelivery;
        }, err => {
            console.log(err);
        });
    }

    /**
     * @returns controllo del menu in base allo slot scelto
     */
    checkMenu() {
        this.provider.checkMenu((<any>this.takeAway.schedule).slot, this.takeHome ? 'home' : 'shop', this.data.menu._id).subscribe(resp => {
            let data = JSON.parse((<any>resp)._body);
            this.isMenuOk = data.result;
        })
    }

    retrieveCustomer() {
        // in hotel mode, recover hotel data
        if (this.data.tavolo.itsHotelRoom) {
            //Use hotel room data
            this.customerInfo = this.data.tavolo.hotelRoom;
        } else if (this.temporaryCustomer) {
            //using data handed from the order manager redirection
            this.customerInfo = this.temporaryCustomer;
            this.mapAddressCode();
        } else {
            // get customer from storage
            this.storage.get('customer').then(
                (customer) => {
                    this.customerInfo = JSON.parse(<any>customer);
                    if (this.data.tavolo.isTakeAway) this.mapAddressCode();
                },
                (err) => console.error(err)
            );
        }
    }

    addAddress() {
        this.takeAway.address = '';
        this.wrongAddress = '';
        let modal = this.modalCtrl.create(AddAddressPage);
        modal.onDidDismiss((data) => {
            let len = (this.customerInfo.addresses).length
            this.retrieveCustomer();
            if (this.customerInfo.addresses.length > 0) this.takeAway.address = this.customerInfo.addresses[len-1].id;
        });
        modal.present();
    }

    addCoupons() {
        this.navCtrl.push(CouponPage);
    }

    deleteCoupon(code) {
        this.coupons.forEach((element, index) => {
            if(element.code == code) this.coupons.splice(index, 1)
        });
        this.provider.setAppliedCoupons(this.coupons);
    }

    isSlotFree(slot) {
        if (this.data.settings.ordersBySlot != 0) {
            let isFull = this.data.settings.ordersBySlot - slot.load;
            if (isFull - this.loadOrder < 0) {
                return true;
            } else {
                return false;
            }
        } else return false;
    }

    callback(teste) {
        console.log(teste);
    }

    sendOrder(when: string, how: string) {
        // disable double press
        if(how == 'SELLA' || how == 'NEXI')
            this.sendOrderInProgressAndPayWithCreditCard = true;
        else 
            this.sendOrderInProgress = true;

        this.translateService
        .get([
            'ERROR_MESSAGE',
            'SUCCESS_MESSAGE',
            'SERVER_NOT_RESPONDING',
            'PAGAMENTO_OK',
            'PAGAMENTO_NOT_OK',
            'PAGAMENTO_INTERROTTO',
            'E1000',
            'E1001',
            'E1002',
            'E1003',
            'E1004',
            'E1005',
            'E1006',
            'E1007',
            'E1008',
            'E1009',
            'E1010',
            'E1011',
            'E1012',
            'E1014'
        ])
        .takeUntil(this._onDestroy)
        .subscribe((msg) => {
            if (this.data.tavolo.isTakeAway || this.data.tavolo.itsHotelRoom) {
            if (!this.data.tavolo.itsHotelRoom) {
                if (this.data.menu.takeAwayOptions == 'home&shop') {
                    if (this.takeHome) {
                        this.takeAway.mode = 'home';
                    } else {
                        this.takeAway.mode = 'shop';
                    }
                } else {
                    this.takeAway.mode = this.data.menu.takeAwayOptions;
                }
            } else if (this.data.menu.itsClassMenu) {
                this.takeAway.mode = 'classroom';
            } else {
                // for hotel mode
                this.takeAway.mode = 'home';
            }

            if (this.data.settings.orderWeightIsOne) {
                (<any>this.takeAway.schedule).load = 1;
            } else if (this.data.settings.shopOrderHasWeightZero && this.takeAway.mode == 'shop') {
                this.loadOrder = 0;
            } else {
                (<any>this.takeAway.schedule).load = this.loadOrder;
            }

            if (this.wrongAddress !== '') {
                return;
            }
            if (this.takeAway.mode == 'shop') this.takeAway.address = '';
            } else if (this.data.tavolo.requireRegisteredUser) {
                if (this.data.menu.itsClassMenu) {
                    this.takeAway.mode = 'classroom';
                } else {
                    this.takeAway.mode = '';
                }

                if (this.wrongAddress !== '') {
                    return;
                }
            } else {
                // normal order without delivery and not hotel mode
                this.customerInfo = null;
            }

            this.provider
            .postOrdini(
                this.hash,
                how,
                when,
                this.righe,
                this.customerInfo,
                this.takeAway,
                this.version,
                this.appVersion,
                this.totalFromServer
            )
            .map((res) => res.json())
            .takeUntil(this._onDestroy)
            .subscribe(
                (ordine) => {
                if (ordine.hasOwnProperty('_id')) {
                    // reset sendOrderInProgress

                    // switch on how
                    switch (how) {
                        case 'NONE':
                        case 'PREPAIDCARD':
                            this.sendOrderInProgress = false;
                            this.navCtrl.push(Success, {
                                message: msg.SUCCESS_MESSAGE,
                                tot: this.infoTakeAway.finalTotal,
                                valuta: this.valuta,
                                takeaway: this.data.tavolo.isTakeAway,
                                deliveryCost: this.takeAway.deliveryCost,
                                deliveryDiscount: this.takeAway.deliveryDiscount,
                            });
                            break;
                        case 'SAFEPAYAFTER':
                            this.sendOrderInProgress = false;
                            this.navCtrl.push(Success, {
                                message: msg.SUCCESS_MESSAGE,
                                tot: this.infoTakeAway.finalTotal,
                                valuta: this.valuta,
                                takeaway: this.data.tavolo.isTakeAway,
                                deliveryCost: this.takeAway.deliveryCost,
                                deliveryDiscount: this.takeAway.deliveryDiscount,
                            });
                            break;
                        case 'NEXI':                            
                            let redirectUrl = `${this.data.settings.nexiRequestURL}?alias=${ordine.alias}&importo=${ordine.totalAmount}&divisa=${ordine.divisa}&codTrans=${ordine.codTrans}&url=${this.url}${ordine.urlPost}&url_back=${this.url}${ordine.urlBack}&mac=${ordine.mac}&urlpost=${this.url}${ordine.urlPost}`
                            
                            let pagamentoSemplice = this.iab.create(redirectUrl, '_blank', this.options);

                            this.paymentTimeout = setTimeout(() => {
                                console.log('PAYMENT TIMEOUT');
                                clearInterval(this.paymentInterval);

                                pagamentoSemplice.close();
                                this.sendOrderInProgressAndPayWithCreditCard = false;
                                this.navCtrl.push(Failure, {
                                    message: msg.SERVER_NOT_RESPONDING,
                                });
                            }, 5 * 60 * 1000);

                            this.paymentInterval = setInterval(() => {
                                this.provider.getNexiOrderStatus(ordine._id).subscribe(
                                    (response) => {
                                        let statusObject = JSON.parse((<any>response)._body);

                                        console.log(`INTERVAL - PAYMENT STATUS: ${statusObject.status}`);

                                        switch (statusObject.status) {
                                            case 'PAYMENT_DECLINED':
                                                console.log('DECLINED');
                                                clearTimeout(this.paymentTimeout);
                                                clearInterval(this.paymentInterval);
                                                pagamentoSemplice.close();
                                                let toast = this.toastCtrl.create({
                                                    message: msg.PAGAMENTO_NOT_OK,
                                                    duration: 3000,
                                                    position: 'middle',
                                                });
                                                toast.present();
                                                this.sendOrderInProgressAndPayWithCreditCard = false;

                                                break;
                                            case 'PAYMENT_APPROVED':
                                                console.log('APPROVED');
                                                clearTimeout(this.paymentTimeout);
                                                clearInterval(this.paymentInterval);
                                                pagamentoSemplice.close();
                                                this.navCtrl.push(Success, {
                                                    message: msg.SUCCESS_MESSAGE,
                                                    tot: this.infoTakeAway.finalTotal,
                                                    valuta: this.valuta,
                                                    takeaway: this.data.tavolo.isTakeAway,
                                                    deliveryCost: this.takeAway.deliveryCost,
                                                    deliveryDiscount: this.takeAway.deliveryDiscount,
                                                });
                                                this.sendOrderInProgressAndPayWithCreditCard = false;
                                                break;
                                            case 'PAYMENT_CANCELLED':
                                                console.log('canceled');
                                                clearTimeout(this.paymentTimeout);
                                                clearInterval(this.paymentInterval);
                                                pagamentoSemplice.close();
                                                let toast1 = this.toastCtrl.create({
                                                    message: msg.PAGAMENTO_INTERROTTO,
                                                    duration: 3000,
                                                    position: 'middle',
                                                });
                                                toast1.present();
                                                this.sendOrderInProgressAndPayWithCreditCard = false;
                                                break;
                                        }
                                    },
                                    (error) => {
                                        console.log('order not found');
                                        console.log(error);
                                    }
                                );
                            }, 3000);

                            break;
                        case 'SELLA':
                            let FIVE_MINUTES = 5 * 60 * 1000;
                            let THREE_SECONDS = 3000;

                            let DECLINED = 'PAYMENT_DECLINED';
                            let APPROVED = 'PAYMENT_APPROVED';

                            let options: InAppBrowserOptions = {
                                location: 'no',
                                hardwareback: 'no',
                                toolbar: 'no',
                                toolbartranslucent: 'no',
                                toolbarposition: 'top',
                                footer: 'no',
                                toolbarcolor: '#FFFFFF',
                            };

                            let url = `${this.url}/ordini/lightbox/${ordine.shoplogin}/${ordine.sellaPayment.paymentId}/${ordine.sellaPayment.paymentToken}`;

                            let browser = this.iab.create(url, '_blank', options);

                            this.paymentTimeout = setTimeout(() => {
                                console.log('PAYMENT TIMEOUT');
                                clearInterval(this.paymentInterval);

                                browser.close();
                                this.sendOrderInProgressAndPayWithCreditCard = false;
                                this.navCtrl.push(Failure, {
                                    message: msg.SERVER_NOT_RESPONDING,
                                });
                            }, FIVE_MINUTES);

                            this.paymentInterval = setInterval(() => {
                                this.provider.getGestPayOrderStatus(ordine._id).subscribe(
                                    (response) => {
                                        let statusObject = JSON.parse((<any>response)._body);

                                        console.log(`INTERVAL - PAYMENT STATUS: ${statusObject.status}`);

                                        switch (statusObject.status) {
                                            case DECLINED:
                                                console.log('DECLINED');
                                                clearTimeout(this.paymentTimeout);
                                                clearInterval(this.paymentInterval);
                                                browser.close();
                                                let toast = this.toastCtrl.create({
                                                    message: msg.PAGAMENTO_NOT_OK,
                                                    duration: 3000,
                                                    position: 'middle',
                                                });
                                                toast.present();
                                                this.sendOrderInProgressAndPayWithCreditCard = false;
                                                break;
                                            case APPROVED:
                                                console.log('APPROVED');
                                                clearTimeout(this.paymentTimeout);
                                                clearInterval(this.paymentInterval);
                                                browser.close();
                                                this.sendOrderInProgressAndPayWithCreditCard = false;
                                                this.navCtrl.push(Success, {
                                                    message: msg.SUCCESS_MESSAGE,
                                                    tot: this.infoTakeAway.finalTotal,
                                                    valuta: this.valuta,
                                                    takeaway: this.data.tavolo.isTakeAway,
                                                    deliveryCost: this.takeAway.deliveryCost,
                                                    deliveryDiscount: this.takeAway.deliveryDiscount,
                                                });
                                                break;
                                        }
                                    },
                                    (error) => {
                                        console.log('order not found');
                                        console.log(error);
                                    }
                                );
                            }, THREE_SECONDS);

                            break;
                        default:
                            console.log('ERRORE: ' + how);
                            break;
                    }
                }
                },
                (err) => {
                    let message: string;
                    switch (err._body) {
                        case 'E1000':
                            message = msg.E1000;
                            break;
                        case 'E1001':
                            message = msg.E1001;
                            break;
                        case 'E1002':
                            message = msg.E1002;
                            break;
                        case 'E1003':
                            message = msg.E1003;
                            break;
                        case 'E1004':
                            message = msg.E1004;
                            break;
                        case 'E1005':
                            message = msg.E1005;
                            break;
                        case 'E1006':
                            message = msg.E1006;
                            break;
                        case 'E1007':
                            message = msg.E1007;
                            break;
                        case 'E1008':
                            message = msg.E1008;
                            break;
                        case 'E1009':
                            message = msg.E1009;
                            break;
                        case 'E1010':
                            message = msg.E1010;
                            break;
                        case 'E1011':
                            message = msg.E1011;
                            break;
                        case 'E1012':
                            message = msg.E1012;
                            break;
                        default:
                            let errBody = JSON.parse((<any>err)._body);
                            if(errBody.code) {
                                if(errBody.code == "E1014")
                                    message = msg.E1014;
                                else
                                    message = errBody.payload + ' - err. ' + errBody.code;
                            } else {
                                console.log(err);
                                console.log(JSON.parse((<any>err)._body))
                                message = err._body + ' - err. ' + msg[err._body];
                            }
                            break;
                    }
                    //this.provider.clearApp();
                    let toast = this.toastCtrl.create({
                        message: message,
                        closeButtonText: 'Ok',
                        showCloseButton: true,
                        position: 'middle',
                    });
                    toast.present();
                    // reset send order flag
                    this.sendOrderInProgress = false;
                }
            );
        });
    }

    isToday(day: Date): Boolean {
        if(moment().isSame(day, 'year') && moment().isSame(day, 'month') && moment().isSame(day, 'day'))
            return true;
        
        return false;
    }

    dismiss() {
        this.viewCtrl.dismiss();
    }
}



// WEBPACK FOOTER //
// ./src/pages/confirm/confirm.ts